import React from 'react';
import {
  DEPARTMENT_FILTER,
  Job,
  JobsFiltersType,
  LOCATIONS_FILTER,
  NAME_FILTER,
  HIDE_CLOSED_JOBS_FILTER,
} from '../types';
import { useTranslation } from 'react-i18next';
import { FilterSelectOption } from '../../../../../atomic/molecules/FlairDropdown/types';
import JobsMultipleFilter from './JobsMultipleFilter';
import JobsTextFilter from './JobsTextFilter';
import JobsCheckboxFilter from './JobsCheckboxFilter';
import { uniqBy } from 'lodash';
import { useObjectLabels } from '../../../hooks/useObjectLabels';

type Props = {
  filterData: JobsFiltersType;
  jobs: Job[];
};

const FilterItem: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = ({ className = '', children }) => {
  return <div className={`me-3 ${className}`}>{children}</div>;
};

const JobsFilters: React.FC<Props> = ({ jobs, filterData }) => {
  const { t } = useTranslation();
  const objectLabels = useObjectLabels();

  const locationOptions: FilterSelectOption[] = uniqBy(
    jobs
      .filter((job) => job.location != null)
      .map((job) => ({
        label: job.location?.Name || '-',
        value: job.location?.Id || '-',
      })),
    'value',
  );

  const departmentOptions: FilterSelectOption[] = uniqBy(
    jobs
      .filter((job) => job.department != null)
      .map((job) => ({
        label: job.department?.Name || '-',
        value: job.department?.Id || '-',
      })),
    'value',
  );

  return (
    <div className="d-flex align-items-center small">
      <FilterItem>
        <JobsTextFilter
          placeholder={t('recruitment.jobsPage.filters.name')}
          filterData={filterData}
          filterKey={NAME_FILTER}
        />
      </FilterItem>
      <FilterItem>
        <JobsMultipleFilter
          options={departmentOptions}
          filterData={filterData}
          filterKey={DEPARTMENT_FILTER}
          placeholder={objectLabels.department}
        />
      </FilterItem>
      <FilterItem>
        <JobsMultipleFilter
          options={locationOptions}
          filterData={filterData}
          filterKey={LOCATIONS_FILTER}
          placeholder={objectLabels.location}
        />
      </FilterItem>
      <FilterItem>
        <JobsCheckboxFilter
          id={HIDE_CLOSED_JOBS_FILTER}
          label={t('recruitment.jobsPage.filters.hideClosedJobs')}
          filterData={filterData}
        />
      </FilterItem>
    </div>
  );
};

export default JobsFilters;
